import { Tag } from 'antd'

// Centralised badge palette so every screen uses the same colours.
// Status colours from spec §18.
const STATUS_COLOR: Record<string, string> = {
  REPORTED:           'default',
  ASSIGNED:           'blue',
  IN_PROGRESS:        'processing',
  WAITING_FOR_SPARES: 'gold',
  COMPLETED:          'green',
  CLOSED:             'default',
  REOPENED:           'magenta',
  OVERDUE:            'red',
  CRITICAL:           'red',
  HIGH:               'orange',
  MEDIUM:             'blue',
  LOW:                'default',
  SAFETY_RISK:        'red',
  AUTO_PROMOTED:      'purple',
  SYSTEM_CALCULATED:  'geekblue',
  MANUAL_OVERRIDE:    'volcano',
  WAITING_APPROVAL:   'gold',
  // Health bands
  HEALTHY:            'green',
  WATCH:              'gold',
  UNDER_OBSERVATION:  'orange',
  STOPPED:            'red',
  // PM
  PLANNED:            'blue',
  DEFERRED:           'purple',
  SKIPPED:            'default',
}

interface Props {
  status: string | null | undefined
  /** Override the readable label (defaults to the raw status). */
  label?: string
}

export default function MaintenanceStatusBadge({ status, label }: Props) {
  if (!status) return <span style={{ color: '#999' }}>—</span>
  const text = (label ?? status).replace(/_/g, ' ')
  return <Tag color={STATUS_COLOR[status] ?? 'default'}>{text}</Tag>
}
